import styled from 'styled-components';

type WrapElementsSmallBigProps = {
    isBigScreen: boolean;
};

export const WrapElementsSmallBig = styled.div<WrapElementsSmallBigProps>`
    display: flex;
    flex-direction: ${({ isBigScreen }) => (isBigScreen ? 'row' : 'column')};

    height: 100%;
`;

type ModalShoppingWrapperProps = {
    cartMobileIsOpen: boolean;
};

export const ModalShoppingWrapper = styled.div<ModalShoppingWrapperProps>`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    /* height: 100%; */
    overflow: hidden;
    /* background-color: red; */
    /* max-height: calc(100% - 2.75rem); */

    flex: 2;
    transition: flex 0.3s ease-in-out;

    @media (max-width: 768px) {
        overflow-x: hidden;
        overflow-y: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE/Edge Legacy */

        /* opacity: ${({ cartMobileIsOpen }) => cartMobileIsOpen && '0.5'}; */

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none; /* Webkit */
        }
    }
`;

// export const ScrollWrap = styled.div`
//     width: 100%;
//     height: 100%;

//     display: block;
//     /* overflow: hidden; */

    
//     border-radius: 1.25rem;

//     @media (max-width: 768px) {
//         margin: 1rem 0rem 14rem 0rem;
//         border-radius: 0.75rem;
//         box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08) inset;
//     }
// `;

export const ShopValuesWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 0;
    flex: 1;
    gap: 0.5rem;

    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge Legacy */
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08) inset;
    border-radius: 1.25rem;
    
    padding: 0.75rem;

    @media (max-width: 768px) {
        padding: 0.3rem;
    }

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none; /* Webkit */
    }
`;

export const HeaderFilters = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;

    @media (max-width: 768px) {
        overflow-x: hidden;
    }
`;

export const ModalFilterHeaderWrap = styled.div`
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    
    @media (max-width: 768px) {
        /* background-color: red; */
        
    }
`;

export const WrapperShoppingModal = styled.div`
    height: auto;
    width: 100%;

    border-radius: 1.25rem; // 20px / 16
    gap: 0.75rem;

    display: flex;
    flex-direction: column;
`;

export const WarnShoppingTextIcon = styled.div`
    height: 100%;
    width: 100%;

    background-color: ${({ theme }) => theme.colors['warn-shopping']};
    border-radius: 0.75rem;
    gap: 0.5rem;

    padding: 0.75rem;

    display: flex;
    align-items: center;
    justify-content: center;

    box-shadow: none;

    color: ${({ theme }) => theme.colors['text-warn']};
`;

export const TextWarn = styled.span`
    font-size: 0.75rem;
    flex: 1;
    font-weight: 500;
`;

type WrapIconCartArrow = {
    isSmallScreen: boolean;
};

export const WrapIconCartArrow = styled.div<WrapIconCartArrow>`
    display: ${({ isSmallScreen }) => (isSmallScreen ? 'none' : 'flex')};
    align-items: start;
    cursor: pointer;
    justify-content: center;

    gap: 0.2rem;
`;

export const WrapFilterDropdownBadge = styled.div`
    display: flex;
    flex-wrap: no-wrap;
    gap: .75rem;

    @media (max-width: 768px) {
        /* background-color: blue; */
        flex-grow: 1;
        flex-wrap: wrap;
        flex-basis: 100%;

        button {
            flex-grow: 1;
            &:not(.dropdown):not(.reservation-day):not(.reservation-arrow) {
                justify-content: center;
            }
            
        }

        button.reservation-arrow {
            flex-grow: 0;
        }

        .wave-side-control {
            flex-grow: 1;
            width: auto;
        }

        .wave-side-control button {
            flex-grow: 1;
            width: 100%;
            min-width: 9rem;
            justify-content: center;
        }

        button.dropdown:first-child {
            /* background-color: purple; */
            flex-grow: 1 !important;
            width: fit-content;

        }

        button.first-heat {
            /* background-color: purple !important; */
            flex-grow: 0;
        }

        button.dropdown:last-child {
            /* background-color: green; */
            /* flex-basis: 100%;
            width: 100%;
            min-width: 100%;
            flex-shrink: 0; */
        }
    }
`;

/* Carousel wrapper — column flex que carrega a régua + indicador de posição */
export const ReservationDayCarouselWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
    gap: 0.3rem;
`;

export const ReservationDayRuler = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
    width: 100%;
`;

export const ReservationDaysList = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex: 1 1 0;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        overflow: hidden;
    }
`;

export const ReservationDayButton = styled.button<{ $dayStatus?: 'available' | 'partial' | 'exhausted' }>`
    border: 1.5px solid ${({ $dayStatus }) =>
        $dayStatus === 'exhausted' ? '#d4d4d8' :
        $dayStatus === 'partial'   ? '#fdba74' :
        $dayStatus === 'available' ? '#86efac' :
        '#d4d4d8'};
    background: ${({ $dayStatus }) =>
        $dayStatus === 'exhausted' ? '#fafafa' :
        $dayStatus === 'available' ? '#f0fdf4' :
        '#ffffff'};
    border-radius: 999px;
    min-width: 4.25rem;
    padding: 0.35rem 0.75rem;
    font-weight: 600;
    font-size: 0.875rem;
    flex-shrink: 0;
    flex-grow: 0;
    transition: transform 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
    cursor: pointer;
    opacity: ${({ $dayStatus }) => $dayStatus === 'exhausted' ? '0.65' : '1'};

    &[aria-selected='true'] {
        background: #ffcf00;
        border-color: #e8b800;
        transform: scale(1.08);
        opacity: 1;
    }

    @media (max-width: 768px) {
        flex: 1 1 0;
        min-width: 0;
        padding: 0.3rem 0.25rem;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.8rem;
    }
`;

export const ReservationDayButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const ReservationDayLabel = styled.span`
    display: block;
    line-height: 1;
`;

export const ReservationDayStatusWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.25rem;
    flex-wrap: wrap;
`;

export const ReservationTypeStatusBadge = styled.span<{ $status: 'available' | 'exhausted' }>`
    border-radius: 999px;
    border: 1px solid ${({ $status }) => ($status === 'available' ? '#86efac' : '#fca5a5')};
    background: ${({ $status }) => ($status === 'available' ? '#f0fdf4' : '#fef2f2')};
    color: ${({ $status }) => ($status === 'available' ? '#166534' : '#991b1b')};
    padding: 0.05rem 0.35rem;
    font-size: 0.58rem;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: 0.02em;
`;

/* Indicador de posição — dots para até 14 dias, contador para mais */
export const ReservationDayDots = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    overflow: hidden;
`;

export const ReservationDayDot = styled.span<{
    $active: boolean;
    $dayStatus?: 'available' | 'partial' | 'exhausted';
}>`
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${({ $active }) => ($active ? '#ffcf00' : '#d4d4d8')};
    box-shadow: none;
    transition: background 0.2s ease, box-shadow 0.2s ease;
`;

export const ReservationDayCounter = styled.span`
    font-size: 0.7rem;
    color: #71717a;
    text-align: center;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.03em;
`;

export const ReservationDayDetailsPanel = styled.div<{ $visible: boolean }>`
    overflow: hidden;
    max-height: ${({ $visible }) => ($visible ? '6rem' : '0')};
    opacity: ${({ $visible }) => ($visible ? '1' : '0')};
    transition: max-height 0.2s ease, opacity 0.15s ease;
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    padding: ${({ $visible }) => ($visible ? '0.4rem 0.5rem' : '0')};
    background: #f8f8f8;
    border-radius: 0.75rem;
`;

export const ReservationDayDetailItem = styled.span<{ $status: 'available' | 'exhausted' }>`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.72rem;
    font-weight: 600;
    color: ${({ $status }) => ($status === 'available' ? '#166534' : '#6b7280')};

    &::before {
        content: '';
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background: ${({ $status }) => ($status === 'available' ? '#4ade80' : '#d4d4d8')};
        flex-shrink: 0;
    }
`;

export const ReservationDaySoldOutAlert = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    flex: 1;
    width: 100%;
    background: transparent;
    border: none;
    color: #9ca3af;
    font-size: 0.8rem;
    font-weight: 900;
    line-height: 1.2;
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const ReservationArrowButton = styled.button`
    border: 1px solid #d4d4d8;
    background: #ffffff;
    border-radius: 999px;
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 0;

    &:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
`;
